import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import CarpentryOrderState from './CarpentryOrderState';
import CarpentryOrderInfo from './CarpentryOrderArticleInfo';
import CarpentryOrderPaletInfo from './CarpentryOrderPaletInfo';

export default function CarpentryOrder(props) {
    const classes = useStyles();

    return <div className={classes.orderContainer}>
        <div className={classes.coloredBorder} style={{ backgroundColor: props.productionOrder.productionOrderStatusForegroundColor }}></div>
        <CarpentryOrderInfo productionOrder={props.productionOrder} {...props}></CarpentryOrderInfo>
        <CarpentryOrderPaletInfo productionOrder={props.productionOrder} {...props}></CarpentryOrderPaletInfo>
        <CarpentryOrderState productionOrder={props.productionOrder} openSwitchRawMaterialDialog={props.openSwitchRawMaterialDialog} setReload={props.setReload} refreshOrders={props.refreshOrders} {...props}></CarpentryOrderState>
    </div>
}

const useStyles = makeStyles({
    orderContainer: {
        backgroundColor: "white",
        borderRadius: "6px",
        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",
        display: 'flex',
        flexDirection: 'row'

    },
    coloredBorder: {
        float: "left",
        width: "7px",
        borderRadius: "6px 0px 0px 6px",
        opacity: "0.28",
        display: 'flex',
        flexDirection: 'column'
    }

});